export default __webpack_public_path__ + "static/media/sign-in-background.90d2effa.jpg";